import { produce } from 'immer'

import { Redux } from 'types/local'
import { Enum } from 'types/enum'

import { headerActions } from './header.actions'

const { types } = headerActions

export type State = Redux.UserState['header']
export const initialState: State = {
  chains: [],
  isLoading: false,
  isConnected: false,
  wallet: null,
  selectedChainId: 56,
  tokenInfo: null,
  signature: null,
  isAuthenticated: false,
  accessToken: null,
  auditProvider: [],
  token: '',
  userInfo: null,
  selectedAddress: null,
}
export const headerReducer = produce((state: State, action: Redux.Action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case types.GET_SUPPORTED_CHAINS.REQUEST:
      state.isLoading = true
      break
    case types.GET_SUPPORTED_CHAINS.SUCCESS:
      state.chains = action.payload
      state.isLoading = false
      break
    case types.GET_SUPPORTED_CHAINS.FAILED:
      state.isLoading = false
      break
    case types.SET_WALLET:
      state.wallet = action.payload
      break
    case types.SET_SELECTED_CHAIN:
      state.selectedChainId = action.payload
      break
    case types.SET_TOKEN_INFO:
      state.tokenInfo = action.payload
      break
    case types.SET_SIGNATURE:
      state.signature = action.payload
      break
    case types.SIGN_IN_CUSTOMER.REQUEST:
      state.isLoading = true
      break
    case types.SIGN_IN_CUSTOMER.SUCCESS:
      state.accessToken = action.payload.token
      state.isAuthenticated = true
      state.isLoading = false
      break
    case types.SIGN_IN_CUSTOMER.FAILED:
      state.isLoading = false
      break
    case types.GET_SUPPORTED_AUDIT_PROVIDER.REQUEST:
      state.isLoading = true
      break
    case types.GET_SUPPORTED_AUDIT_PROVIDER.SUCCESS:
      state.auditProvider = action.payload
      state.isLoading = false
      break
    case types.GET_SUPPORTED_AUDIT_PROVIDER.FAILED:
      state.isLoading = false
      break
    case types.SET_TOKEN:
      state.token = action.payload
      break
    case types.SET_USER:
      state.userInfo = action.payload
      break
    case types.SET_SELECTED_ADDRESS:
      state.selectedAddress = action.payload
      break
  }
}, initialState)
